import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { IInformationMessage } from "@faire/web-api--source/indigofair/data/IInformationMessage";
import { observer } from "mobx-react";
import React from "react";
import { useHistory } from "react-router-dom";
import { openFDCreditFAQModal } from "@faire/retailer/components/App/AppModals/utils";
import { useFaireDirectFirstOrderIncentive } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectFirstOrderIncentive/useFaireDirectFirstOrderIncentive";
import { useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { MarketPromoLine } from "@faire/retailer/views/product/ProductDetails/__internal__/Header/MarketPromoLine";
import { SimpleProductPromo } from "@faire/retailer/views/product/ProductDetails/__internal__/Header/SimpleProductPromotions";
var ProductDetailsPromotionBase = function(param) {
    var brandPromotion = param.brandPromotion, brand = param.brand, productPromotionsState = param.productPromotionsState, product = param.product;
    var _productPromotionsState_marketPromo;
    var _useFaireDirectFirstOrderIncentive = useFaireDirectFirstOrderIncentive(), brandName = _useFaireDirectFirstOrderIncentive.brandName, isFaireDirectCreditPercentageBased = _useFaireDirectFirstOrderIncentive.isFaireDirectCreditPercentageBased, formattedPercentageBasedNumber = _useFaireDirectFirstOrderIncentive.formattedPercentageBasedNumber, formattedFixedBasedAmount = _useFaireDirectFirstOrderIncentive.formattedFixedBasedAmount, hasIncentiveAndBrandTokenMatches = _useFaireDirectFirstOrderIncentive.hasIncentiveAndBrandTokenMatches;
    var history = useHistory();
    var isPreOrderExcludedForBrandPromo = useMarketStore([
        "isPreOrderExcludedForBrandPromo"
    ]).isPreOrderExcludedForBrandPromo;
    var _brand_token;
    if (hasIncentiveAndBrandTokenMatches((_brand_token = brand === null || brand === void 0 ? void 0 : brand.token) !== null && _brand_token !== void 0 ? _brand_token : "")) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "1x"
                }),
                /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraphSansRegular",
                        color: Decorative.shade.orange,
                        children: isFaireDirectCreditPercentageBased ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "507W/0",
                            defaultMessage: [
                                {
                                    type: 1,
                                    value: "faireDirectPercentageDiscountNumber"
                                },
                                {
                                    type: 0,
                                    value: " off & 1 year of free shipping. "
                                },
                                {
                                    type: 8,
                                    value: "LinkFormatting",
                                    children: [
                                        {
                                            type: 0,
                                            value: "Learn more"
                                        }
                                    ]
                                }
                            ],
                            values: {
                                faireDirectPercentageDiscountNumber: formattedPercentageBasedNumber,
                                LinkFormatting: OpenFDCreditFAQModalLink(brand, history, brandName !== null && brandName !== void 0 ? brandName : "")
                            }
                        }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "mqJc54",
                            defaultMessage: [
                                {
                                    type: 1,
                                    value: "incentiveMoney"
                                },
                                {
                                    type: 0,
                                    value: " off & 1 year of free shipping. "
                                },
                                {
                                    type: 8,
                                    value: "LinkFormatting",
                                    children: [
                                        {
                                            type: 0,
                                            value: "Learn more"
                                        }
                                    ]
                                }
                            ],
                            values: {
                                incentiveMoney: formattedFixedBasedAmount,
                                LinkFormatting: OpenFDCreditFAQModalLink(brand, history, brandName !== null && brandName !== void 0 ? brandName : "")
                            }
                        })
                    })
                })
            ]
        });
    }
    var isPreOrderProductAndExcludedFromMarketPromo = (product === null || product === void 0 ? void 0 : product.preorderable) && isPreOrderExcludedForBrandPromo(brandPromotion === null || brandPromotion === void 0 ? void 0 : brandPromotion.promotional_event_type, brandPromotion === null || brandPromotion === void 0 ? void 0 : brandPromotion.ship_availability);
    if (productPromotionsState === null || productPromotionsState === void 0 ? void 0 : (_productPromotionsState_marketPromo = productPromotionsState.marketPromo) === null || _productPromotionsState_marketPromo === void 0 ? void 0 : _productPromotionsState_marketPromo.text) {
        return !isPreOrderProductAndExcludedFromMarketPromo ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "2x"
                }),
                /*#__PURE__*/ _jsx(MarketPromoLine, {
                    promotion: productPromotionsState.marketPromo.text
                })
            ]
        }) : null;
    }
    return /*#__PURE__*/ _jsx(SimpleProductPromo, {
        promotions: productPromotionsState === null || productPromotionsState === void 0 ? void 0 : productPromotionsState.promotionStyleBanners,
        position: IInformationMessage.Position.DEFAULT
    });
};
export var ProductDetailsPromotion = observer(ProductDetailsPromotionBase);
var OpenFDCreditFAQModalLink = function(brand, history, brandName) {
    return function OpenFDCreditFAQModalLink(chunk) {
        return /*#__PURE__*/ _jsx(EmbeddedLink, {
            style: {
                color: Decorative.shade.orange,
                textDecorationColor: Decorative.shade.orange
            },
            onClick: function() {
                var _brand_name;
                return openFDCreditFAQModal((_brand_name = brand === null || brand === void 0 ? void 0 : brand.name) !== null && _brand_name !== void 0 ? _brand_name : brandName, history, brand === null || brand === void 0 ? void 0 : brand.minimum_order_amount);
            },
            children: chunk
        });
    };
};
